import { createSlice } from '@reduxjs/toolkit';

const initialState = false;

const disclaimerSlice = createSlice({
  name: 'disclaimer',
  initialState,
  reducers: {
    setDisclaimer: (state, action: { type: string; payload: boolean }) => {
      return action.payload;
    },
  },
});

export const { setDisclaimer } = disclaimerSlice.actions;

export default disclaimerSlice.reducer;
